const reportTypes = {
  CREATE_REPORT: 'CREATE_REPORT',
  FETCH_REPORTS: 'FETCH_REPORTS',
  SET_REPORTS: 'SET_REPORTS',
  FETCH_SINGLE_REPORT: 'FETCH_SINGLE_REPORT',
  SET_SINGLE_REPORT: 'SET_SINGLE_REPORT',
  FETCH_TESTS: 'FETCH_TESTS',
  SET_TESTS: 'SET_TESTS',
  EDIT_TESTS: 'EDIT_TESTS',
  DELETE_SINGLE_REPORT: 'DELETE_SINGLE_REPORT',
  SAVE_PROCEDURE: 'SAVE_PROCEDURE',
  CREATE_DIAGNOSTIC_FINDING: 'CREATE_DIAGNOSTIC_FINDING',
  ADD_DIAGNOSTIC_NOTES: 'ADD_DIAGNOSTIC_NOTES',
  FETCH_FINDINGS_PER_PROCEDURE: 'FETCH_FINDINGS_PER_PROCEDURE',
  FETCH_NOTES_PER_FINDINGS: 'FETCH_NOTES_PER_FINDINGS',
  EDIT_DIAGNOSTIC_FINDINGS: 'EDIT_DIAGNOSTIC_FINDINGS',
  EDIT_DIAGNOSTIC_FINDINGS_NOTE: 'EDIT_DIAGNOSTIC_FINDINGS_NOTE',
  DELETE_DIAGNOSTIC_FINDINGS: 'DELETE_DIAGNOSTIC_FINDINGS'
};

export default reportTypes;
